import { DietRefDatesStayDto } from '../Type/DietRefDatesStayDto'

export class DietRefDatesStay {
    public constructor(public dateType: string, public date: Date, public label: string) {}

    public formateItemToFormData(): DietRefDatesStayDto {
        return {
            dateType: this.dateType,
            date: this.date,
            label: this.label,
        }
    }
}
